<template>
    <client-page class="app--main">
        <div class="visual">
            <div class="background">
                <div class="visual__con">
                    <div class="text-ani-wrap">
                        <div class="text-ani mb-14 mb-lg-30">
                            <h2 class="main-tit visual__tit">
                                글로벌 생산성 및 친환경
                            </h2>
                        </div>
                        <div class="text-ani">
                            <p class="visual__txt">
                                메이텍스타일(Meitextile)은 매년 R&D의 장점을 활용하여
                            </p>
                        </div>
                        <div class="text-ani">
                            <p class="visual__txt">
                                글로벌 생산성과 빠른 대응으로 시장 트렌드에 발맞추며,
                            </p>
                        </div>
                        <div class="text-ani">
                            <p class="visual__txt">
                                지속 가능한 친환경 아이템 개발에 힘쓰고 있습니다.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="video-bg">
                    <video playsinline muted loop autoplay poster="/images/main/visual-poster.jpg" class="video-bg__video">
                        <source src="/images/main/visual.mp4" type="video/mp4" />
                        <strong>웹 브라우저가 video를 지원하지 않습니다.</strong>
                    </video>
                </div>
            </div>
        </div>

        <div class="main-contents">
            <section class="main-section main-section--first">
                <v-container>
                    <div class="prd-slide">
                        <div class="swiper-container">
                            <div class="swiper-control">
                                <div class="control-top">
                                    <h2 class="main-tit mb-lg-46 mb-xl-92" data-aos="fade-up">Product</h2>
                                    <div class="pagination"></div>
                                </div>
                                <div class="control-bottom">
                                    <v-btn icon tile large color="white" class="prev-btn"><i class="icon icon-left-arrow"></i></v-btn>
                                    <v-btn icon tile large color="white" class="next-btn"><i class="icon icon-right-arrow"></i></v-btn>
                                </div>
                            </div>
                            <div class="swiper-wrapper">
                                <div class="swiper-slide">
                                    <main-product link="/ko/product/organic" mainImage="/images/main/prd-1.jpg" slideImage1="/images/main/prd-1-1.jpg" slideImage2="/images/main/prd-1-2.jpg" slideImage3="/images/main/prd-1-3.jpg" slideImage4="/images/main/prd-1-4.jpg" slideImage5="/images/main/prd-1-5.jpg" tit="Organic Line">
                                        유기농 코튼, BCI코튼, 리싸이클 폴리에스터, 대나무 섬유, 옥수수 섬유(소로나), 에코베로 등. 환경 문제가 대두됨에 따라 원단 시장 또한 변화하고 있습니다. 메이텍스는 환경 인증된 공장들과 협력하며 다양한 친환경 소재를 다루고 있습니다.
                                    </main-product>
                                </div>
                                <div class="swiper-slide">
                                    <main-product link="/ko/product/sports" mainImage="/images/main/prd-2.jpg" slideImage1="/images/main/prd-2-1.jpg" slideImage2="/images/main/prd-2-2.jpg" slideImage3="/images/main/prd-2-3.jpg" tit="High Function Sports Line">
                                       방습성/발수성, 쿨링/히팅 기능으로 소비자의 건강한 삶을 도와줍니다. 기능성 실과 니팅 구조로 다양한 기능성을 구체화 시킵니다. 소비자의 삶을 풍요롭게 하는 다양한 아이템을 만나보세요.
                                    </main-product>
                                </div>
                                <div class="swiper-slide">
                                    <main-product link="/ko/product/active" mainImage="/images/main/prd-3.jpg" slideImage1="/images/main/prd-3-1.jpg" slideImage2="/images/main/prd-3-2.jpg" slideImage3="/images/main/prd-3-3.jpg" slideImage4="/images/main/prd-3-4.jpg" slideImage5="/images/main/prd-3-5.jpg" tit="Active & Legging line">
                                        프린팅과 포일 디자인을 더한 싱글/더블 니트, 다양한 패턴의 엠보싱, 고신축성과 리커버리를 가진 아이템. 스포츠 및 레깅스 아이템에 대해 경험이 풍부하며 합리적인 가격으로  많은 브랜드와 협력하고 있습니다.
                                    </main-product>
                                </div>
                                <div class="swiper-slide">
                                    <main-product link="/ko/product/cotton" mainImage="/images/main/prd-4.jpg" slideImage1="/images/main/prd-4-1.jpg" slideImage2="/images/main/prd-4-2.jpg" slideImage3="/images/main/prd-4-3.jpg" slideImage4="/images/main/prd-4-4.jpg" slideImage5="/images/main/prd-4-5.jpg" tit="Cotton & Basic Line">
                                        싱글/더블 니트와 립, 테리, 트리코트, BCI 코튼 US 코튼, 유기농 코튼, 실켓 코튼과 더불어 다양한 혼방 섬유를 다룹니다. 고급스러운 코튼 원단부터 합리적인 가격의 옵션까지 커버하는 베이직 니트 아이템을 생산합니다.
                                    </main-product>
                                </div>
                                <div class="swiper-slide">
                                    <main-product link="/ko/product/fleece" mainImage="/images/main/prd-5.jpg" slideImage1="/images/main/prd-5-1.jpg" slideImage2="/images/main/prd-5-2.jpg" slideImage3="/images/main/prd-5-3.jpg" slideImage4="/images/main/prd-5-4.jpg" slideImage5="/images/main/prd-5-5.jpg" tit="Fleece & Sherpa Line">
                                        단/장 섬유의 셰르파와 폴라 플리스, 밍크 플리스, 테리 플리스, 벨루어, 브러쉬드 니트 등. 합성, 혼방 섬유 셰르파와 플리스 원단에 풍부한 경험을 가지며, 특히 뛰어난 품질과 가격을 만나보실 수 있습니다.
                                    </main-product>
                                </div>
                                <div class="swiper-slide">
                                    <main-product link="/ko/product/novelty" mainImage="/images/main/prd-6.jpg" slideImage1="/images/main/prd-6-1.jpg" slideImage2="/images/main/prd-6-2.jpg" slideImage3="/images/main/prd-6-3.jpg" slideImage4="/images/main/prd-6-4.jpg" slideImage5="/images/main/prd-6-5.jpg" tit="Novelty Line">
                                        번아웃과 고급스러운 나염, 특별한 후가공, 다양한 패턴의 자카드와 엠보싱 등. 한국의 숙련된 기술로 가공한 특별한 품목들을 만나실 수 있습니다.
                                    </main-product>
                                </div>
                                <div class="swiper-slide">
                                    <main-product link="/ko/product/Comfortable" mainImage="/images/main/prd-7.jpg" slideImage1="/images/main/prd-7-1.jpg" slideImage2="/images/main/prd-7-2.jpg" slideImage3="/images/main/prd-7-3.jpg" slideImage4="/images/main/prd-7-4.jpg" slideImage5="/images/main/prd-7-5.jpg" tit="Comfortable & Cozy Line">
                                        싱글니트와 타월 테리, 플리스, 텍스쳐 니트 등. 브러쉬 효과와 더불어 다양한 조직을 구현합니다. 홈웨어와 더불어 다양한 룩을 연출하는 소프트 니트 라인은 소비자에게 편안함과 쾌적함을 선사합니다.
                                    </main-product>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-container>
            </section>
            <section class="main-section main-section--last">
                <v-container>
                    <h2 class="main-tit text-center" data-aos="fade-up">Partner Brand</h2>
                    <v-row>
                        <v-col cols="6" md="3" v-for="(banner, idx) in banners" :key="idx">
                            <div class="partner-thum-wrap">
                                <v-img class="partner-thum" :src="banner.slides[0].image"></v-img>
                            </div>
                        </v-col>
                    </v-row>

                    <div id="moreView" class="mt-10 mt-lg-24">
                        <v-row>
                            <v-col cols="6" md="3" v-for="(banner, idx) in banners2" :key="idx">
                                <div class="partner-thum-wrap">
                                    <v-img class="partner-thum" :src="banner.slides[0].image"></v-img>
                                </div>
                            </v-col>
                        </v-row>
                    </div>

                    <div class="d-flex justify-center mt-40 mt-lg-80">
                        <div id="moreBtn">
                            <v-btn outlined color="primary" class="min-w-160px min-w-lg-200px" @click="add">View All <span class="ml-6 ml-lg-10 plus more-view-btn"></span></v-btn>
                        </div>
                    </div>
                </v-container>
            </section>
        </div>

        <popup-layer></popup-layer>
    </client-page>
</template>

<script>
import api from "@/api";

import Swiper from "swiper/bundle";
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import MainProduct from "@/components/client/ko/main/main-product.vue";

export default {
    components: {
        ClientPage,
        PopupLayer,
        MainProduct,
    },
    mounted: function() {
        this.getBrand();
        setTimeout(() => {
            AOS.init({
                once: false,
                offset: 240,
                duration: 500,
                throttleDelay: 100,
                easing: "ease-in-out",
                anchorPlacement: "top-center",
            });
            this.init();
        }, 100);
    },
    data() {
        return {
            banners: {},
            banners2: {},
        };
    },
    methods: {
        async getBrand() {
            let { banners } = await api.v1.banners.gets({ headers: { limit: 16 } });
            this.banners = banners;
            console.log(this.banners);
        },
        async init() {
            this.$nextTick(() => {
                //prd-slide
                this.$nextTick(() => {
                    this.swiper = new Swiper(".prd-slide .swiper-container", {
                        allowTouchMove: true,
                        spaceBetween: 100,
                        slidesPerView: 1,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                        },
                        speed: 500,
                        loop: true,
                        pagination: {
                            el: ".prd-slide .pagination",
                            clickable: true,
                            renderBullet: function(index, className) {
                                return '<span class="' + className + '"> 0' + (index + 1) + "</span>";
                            },
                        },
                        navigation: {
                            nextEl: ".prd-slide .next-btn",
                            prevEl: ".prd-slide .prev-btn",
                        },
                        breakpoints: {
                            1200: {
                                slidesPerView: 2,
                            },
                        },
                    });
                });

                // moreview
                const moreView = document.getElementById("moreView");
                document.getElementById("moreBtn").onclick = function() {
                    var className = " " + moreView.className + " ";

                    if (~className.indexOf(" active ")) {
                        moreView.className = className.replace(" active ", " ");
                    } else {
                        moreView.className += " active ";
                    }
                };
            });
        },
        async add() {
            let { banners } = await api.v1.banners.gets({ headers: { skip: 16 } });
            this.banners2 = banners;
            console.log(this.banners2);
        },
    },
};
</script>

<style lang="scss" scoped>
.main-contents {
    position: relative;
}
.main-contents::before {
    content: "";
    display: block;
    position: absolute;
    width: 100px;
    height: 100%;
    background-color: #f7f8f9;
    left: 0;
    top: 0;
    z-index: 0;
}

.main-contents .main-section {
    position: relative;
    z-index: 1;
}

@media (min-width: 576px) {
    .main-contents::before {
        width: 200px;
    }
}
@media (min-width: 768px) {
    .main-contents::before {
        width: 360px;
    }
}
@media (min-width: 1024px) {
    .main-contents::before {
        width: 420px;
    }
}
@media (min-width: 1200px) {
    .main-contents::before {
        width: 540px;
    }
}

#moreView {
    overflow: hidden;
    max-height: 0;
    transition: 1.5s linear;
}
#moreView.active {
    max-height: 100vw;
}
</style>
